import {useMemo} from "react";
import {useSetting} from "contexts/setting";
import {useCurrentSet} from "hooks/useCurrentSet";
import {useTemplateSelection} from "hooks/useTemplateSelection";
import {getRouteTemplates} from "utils/routeTemplates";

/**
 * The banners this page draws: the route's list (utils/routeTemplates.ts) with
 * the design of each slot that the page's template selection puts on air, and
 * without the banners an admin removed. Every page draws through this, so the
 * pages, the background selector and the Defaults panel cannot disagree.
 */
export function useRouteTemplates(channel: string) {
  const {layoutOption, product, type, hiddenTemplates, extraTemplates} = useSetting();
  const set = useCurrentSet();
  const selection = useTemplateSelection();
  const productValue = product?.value;
  const typeValue = type?.value;
  return useMemo(
    () =>
      getRouteTemplates(channel, {
        layoutOption,
        set,
        product: productValue,
        type: typeValue,
        hiddenTemplates,
        extraTemplates,
        selection,
      }),
    [channel, layoutOption, set, productValue, typeValue, hiddenTemplates, extraTemplates, selection]
  );
}
